/* Shopify validates the purchase-qualified gift discount at cart and checkout. */
(() => {
  'use strict';
  function validateGiftCart(cart, eligibleIds, giftId, giftExpected) {
    const paid = cart.items.some(item => eligibleIds.includes(String(item.variant_id)) && item.final_line_price > 0);
    const gifts = cart.items.filter(item => String(item.variant_id) === String(giftId));
    if (!paid || !(cart.total_price > 0)) return 'paid_bundle_required';
    if (giftExpected && (gifts.reduce((sum, item) => sum + item.quantity, 0) !== 1 || gifts.some(item => item.final_line_price !== 0))) return 'gift_discount_missing';
    return null;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { validateGiftCart };
  if (typeof document === 'undefined') return;
  const form = document.getElementById('mv-buy-form');
  const configElement = document.getElementById('mh-commerce-config');
  if (!form || !configElement) return;
  const config = JSON.parse(configElement.textContent);
  const root = (config.root || '/').replace(/\/?$/, '/');
  const button = form.querySelector('[type="submit"]');
  const bundles = [...form.querySelectorAll('.mv-bundle')];
  const variants = new Map((config.product?.variants || []).map(v => [String(v.id), v]));
  const gift = config.gift?.variants?.find(v => v.available && v.price > 0);
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:config.currency || 'USD'}).format(value/100);
  const status = document.createElement('p');
  status.setAttribute('role','status'); status.setAttribute('aria-live','polite'); status.hidden = true;
  status.style.cssText = 'margin:12px 0;color:#9e2435;font-size:14px;line-height:1.4';
  form.append(status);
  let submitting = false;
  const message = text => {status.textContent=text;status.hidden=!text;};
  const selected = () => variants.get(form.querySelector('input[name="id"]:checked')?.value);
  window.MeravaeGiftSavings = state => {
    const variant=selected();
    if (!variant) return;
    const baseSavings=Math.max(0,(variant.compare_at_price||variant.price)-variant.price);
    const giftValue=state?.active && gift ? gift.price : 0;
    form.querySelector('[data-sum-save]').textContent=money(baseSavings+giftValue);
  };
  const update = () => {
    bundles.forEach(card => {
      const input=card.querySelector('input');const variant=variants.get(input.value);
      input.disabled=!variant?.available || variant.price<=0;
      card.classList.toggle('is-active',input.checked);
      if (!variant) return;
      const units=card.querySelectorAll('.mv-b-thumb img').length;
      card.querySelector('.mv-b-now').textContent=money(Math.round(variant.price/units));
      card.querySelector('.mv-b-save').textContent='Save '+money(Math.max(0,(variant.compare_at_price||variant.price)-variant.price));
    });
    const variant=selected();
    if (variant) {
      form.querySelector('[data-sum-now]').textContent=money(variant.price);
      form.querySelector('[data-sum-was]').textContent=money(variant.compare_at_price||variant.price);
      window.MeravaeGiftSavings(window.MeravaeSeasonalBonus?.getCurrentState());
    }
    const active=window.MeravaeSeasonalBonus?.getCurrentState().active;
    button.disabled=submitting || !variant?.available || variant.price<=0 || (active && !gift);
    if (!variant?.available) message('This bundle is currently unavailable for delivery to '+(config.countryName||'your location')+'.');
    else if (active && !gift) message('The gift is currently unavailable for your location. Please contact us before ordering.');
    else if (!submitting) message('');
  };
  if (!selected()?.available) {
    const first=bundles.find(card=>variants.get(card.querySelector('input').value)?.available);
    if(first)first.querySelector('input').checked=true;
  }
  form.addEventListener('change',update);
  const request = async (path, data) => {
    const response=await fetch(root+path,{method:data?'POST':'GET',headers:{Accept:'application/json',...(data?{'Content-Type':'application/json'}:{})},...(data?{body:JSON.stringify(data)}:{})});
    const result=await response.json();
    if(!response.ok) throw new Error(result.description||result.message||'Please check your connection and try again.');
    return result;
  };
  form.addEventListener('submit',async event=>{
    event.preventDefault();if(submitting)return;
    const variant=selected();const bonus=window.MeravaeSeasonalBonus?.refresh();
    if(!variant?.available || !(variant.price>0)) {update();return;}
    if(bonus?.active && !gift) {update();return;}
    submitting=true;button.disabled=true;button.setAttribute('aria-busy','true');message('Preparing your order…');
    try {
      let cart=await request('cart.js');
      const giftLines=cart.items.filter(item=>String(item.variant_id)===String(gift?.id));
      // Dedicated seasonal gift: retain at most one, never add a duplicate on return.
      for (const [index,item] of giftLines.entries()) {
        const quantity=bonus?.active && index===0?1:0;
        if(item.quantity!==quantity) cart=await request('cart/change.js',{id:item.key,quantity});
      }
      const items=[{id:variant.id,quantity:1}];
      if(bonus?.active && !giftLines.length)items.push({id:gift.id,quantity:1,properties:{_meravae_campaign:'halloween-2026'}});
      await request('cart/add.js',{items});
      cart=await request('cart.js');
      const error=validateGiftCart(cart,[...variants.keys()],gift?.id,bonus?.active);
      const gifts=cart.items.filter(item=>String(item.variant_id)===String(gift?.id));
      if(error==='paid_bundle_required')throw new Error('Please select an eligible paid bundle to claim your gift.');
      if(error==='gift_discount_missing') {
        for(const item of gifts)await request('cart/change.js',{id:item.key,quantity:0});
        throw new Error('We could not apply your free gift. Your paid bundle is in the cart, but checkout has not started. Please contact us for help.');
      }
      window.location.assign(root+'checkout');
    } catch(error) {
      message(error.message||'Your order could not be prepared. Please check your cart before trying again.');
      submitting=false;button.disabled=false;button.removeAttribute('aria-busy');
    }
  });
  window.addEventListener('pageshow',()=>{submitting=false;button.removeAttribute('aria-busy');update();});
  document.addEventListener('visibilitychange',update);
  update();
})();
